import React from 'react';
import PropTypes from 'prop-types';
import Autocomplete from '../../../Autocomplete';

const SuggestionFilter = ({
  margin,
  onChange,
  operator,
  settings,
  suggestions,
  value,
  ...props
}) => {
  const { enableCreate = true, multiple = true } = settings;

  const handleChange = (ev, selectedSuggestions) => {
    if (onChange && typeof onChange === 'function') {
      if (enableCreate) {
        const values = selectedSuggestions.reduce((acc, suggestion) => {
          if (typeof suggestion === 'object') {
            return [...acc, suggestion?.value];
          }

          return [...acc, suggestion];
        }, []);
        onChange(ev, values);
      } else {
        const values = selectedSuggestions.map(selectedSuggestion => selectedSuggestion?.value);
        onChange(ev, values);
      }
    }
  };

  return (
    <Autocomplete
      {...props}
      onChange={handleChange}
      options={suggestions}
      multiple={multiple}
      value={value ?? []}
      enableCreate={enableCreate}
      autocomplete="off"
      margin={margin}
    />
  );
};

SuggestionFilter.propTypes = {
  margin: PropTypes.string,
  onChange: PropTypes.func,
  operator: PropTypes.string,
  settings: PropTypes.object,
  suggestions: PropTypes.array,
  value: PropTypes.array,
};

SuggestionFilter.defaultProps = {
  margin: undefined,
  onChange: undefined,
  operator: undefined,
  settings: {},
  suggestions: [],
  value: [],
};

export default SuggestionFilter;
